import BaseXAxis from "../../sisu/chart/BaseXAxis.sisu";

const NeoXAxis = BaseXAxis

export default NeoXAxis;